import * as _ from 'lodash';
import moment from 'moment';
import { TreeNode } from 'primeng/api';

export const getLeafNodesFromSelected = (selectedNodes: TreeNode[]): any[] => {
  let leafNodes = getLeafNodes(selectedNodes);
  return _.map(_.uniqBy(leafNodes, a => a.key), b => b.key);
}


const getLeafNodes = (selectedNodes: TreeNode[]): TreeNode[] => {
  let leafNodes: TreeNode[] = [];
  for (const node of selectedNodes) {
    if (!node.children || node.children.length === 0) {
      // If the node has no children, it is a leaf node
      leafNodes.push(node);
    } else {
      // If the node has children, recursively extract leaf nodes from its children
      const childLeafNodes = getLeafNodes(node.children);
      leafNodes = leafNodes.concat(childLeafNodes);
    }
  }
  return leafNodes;
}


export const SK_CreateForecastAccountTree = ({
  dataList = [],
  mappedValueList = [],
  disableValueList = [],
  isAllChecked = false,
  isAllDisabled = false,
  selectable = true,
  expanded = false,
  nodeClass = ''
}: any) => {
  const channels = _.uniqBy(dataList, (a: any) => a.channel);

  let treeList: any = [];
  channels.forEach((channel: any) => {
    let channelObject: any = {
      label: channel.channel,
      key: channel.channel,
      data: channel,
      icon: '',
      leaf: false,
      expanded: false,
      type: '',
      partialSelected: mappedValueList.length > 0 && mappedValueList.includes(channel.retailerKey),
      styleClass: nodeClass,
      draggable: false,
      droppable: false,
      selectable: selectable,
      isRoot: true,
      level: 1,
      children: []
    };
    const regions = _.uniqBy(_.filter(dataList, (a: any) =>
      a.channel === channel.channel
    ), (b: any) => b.region);
    regions.forEach((region: any) => {
      let regionObject: any = {
        label: region.region,
        key: region.region,
        data: region,
        icon: '',
        leaf: false,
        expanded: false,
        type: '',
        partialSelected: mappedValueList.length > 0 && mappedValueList.includes(region.retailerKey),
        styleClass: nodeClass,
        draggable: false,
        droppable: false,
        selectable: selectable,
        isRoot: true,
        level: 2,
        children: []
      };
      const countries = _.uniqBy(_.filter(dataList, (a: any) => a.channel === channel.channel && a.region === region.region), (b: any) => b.country);
      countries.forEach((country: any) => {
        let countryObj: any = {
          label: country.country,
          key: country.country,
          data: country,
          icon: '',
          leaf: false,
          expanded: false,
          type: '',
          partialSelected: mappedValueList.length > 0 && mappedValueList.includes(country.retailerKey),
          styleClass: nodeClass,
          draggable: false,
          droppable: false,
          selectable: selectable,
          isRoot: true,
          level: 3,
          children: []
        };

        let retailers = _.uniqBy(_.filter(dataList, (a: any) =>
          a.country === country.country &&
          a.region === region.region &&
          a.channel === channel.channel), (b: any) => b.retailer);
        retailers = retailers.map((row: any) => ({
          label: row.retailer,
          key: row.retailerKey,
          data: row,
          icon: '',
          leaf: true,
          expanded: false,
          type: '',
          partialSelected: mappedValueList.length > 0 && mappedValueList.includes(row.retailerKey),
          styleClass: nodeClass,
          draggable: false,
          droppable: false,
          selectable: selectable,
          isRoot: true,
          level: 4,
        }));
        countryObj.children = retailers;
        if (regionObject) {
          regionObject.children.push(countryObj);
        }
      });
      if (regionObject) {
        channelObject.children.push(regionObject);
      }
    });
    treeList.push(channelObject);
  });

  return treeList;
};

export const treeNodeSelection = 
({

  item = [], 
  isAllSelectable = true, 
  isAllExpanded = false, 
},
result : any = []
) : any => {

  if(item.length === 0){
    return;
  }
  item.forEach((elem : any) => {
    if(!isAllSelectable) 
      elem['selectable'] = false;
    if(!isAllExpanded) 
      elem.expanded = false;
    result.push(elem);
    if(!elem.children)
      return result;
    treeNodeSelection(
        {
          item : elem.children,
          isAllSelectable : isAllSelectable, 
          isAllExpanded : isAllExpanded
        }, result);
  })
  return result;
}

export const SK_CreateForecastItemTree = ({
  dataList = [],
  mappedValueList = [],
  disableValueList = [],
  isAllChecked = false,
  isAllDisabled = false,
  selectable = true,
  expanded = false,
  nodeClass = ''
}: any) => {
  const brands = _.uniqBy(dataList, (a: any) => a.brand);

  let treeList: any = [];
  brands.forEach((brand: any) => {
    let brandsObject: any = {
      label: brand.brand,
      key: brand.brand,
      data: brand,
      icon: '',
      leaf: false,
      expanded: false,
      type: '',
      partialSelected: isAllChecked || false,
      styleClass: nodeClass,
      draggable: false,
      droppable: false,
      selectable: selectable,
      isRoot: true,
      level: 1,
      children: [],
      // checked: mappedTimeFrame.length > 0 && mappedTimeFrame.includes(yearList.weekNumber),
    };

    const productGroups = _.uniqBy(_.filter(dataList, (a: any) =>
      a.brand === brand.brand
    ), (b: any) => b.productGroup);

    productGroups.forEach((productGroup: any) => {
      let productGroupObject: any = {
        label: productGroup.productGroup,
        key: productGroup.productGroup,
        data: productGroup,
        icon: '',
        leaf: false,
        expanded: false,
        type: '',
        partialSelected: isAllChecked || false,
        styleClass: nodeClass,
        draggable: false,
        droppable: false,
        selectable: selectable,
        isRoot: true,
        level: 2,
        children: [],
        // checked: mappedTimeFrame.length > 0 && mappedTimeFrame.includes(yearList.weekNumber),
      };

      const parentProducts = _.uniqBy(_.filter(dataList, (a: any) => a.brand === brand.brand && a.productGroup === productGroup.productGroup), (b: any) => b.parentProduct);

      parentProducts.forEach((parentProduct: any) => {
        let parentProductObject: any = {
          label: parentProduct.parentProduct,
          key: parentProduct.parentProduct,
          data: parentProduct,
          icon: '',
          leaf: false,
          expanded: false,
          type: '',
          partialSelected: isAllChecked || false,
          styleClass: nodeClass,
          draggable: false,
          droppable: false,
          selectable: selectable,
          isRoot: true,
          level: 3,
          children: [],
          // checked: mappedTimeFrame.length > 0 && mappedTimeFrame.includes(yearList.weekNumber),
        };
        const productDescriptions = _.uniqBy(_.filter(dataList, (a: any) =>
          a.brand === brand.brand
          && a.productGroup === productGroup.productGroup
          && a.parentProduct === parentProduct.parentProduct
        ), (b: any) => b.productDescription);

        productDescriptions.forEach((productDescription: any) => {
          let productDescriptionObject: any = {
            label: productDescription.productDescription,
            key: productDescription.itemKey,
            data: productDescription,
            icon: '',
            leaf: true,
            expanded: false,
            type: '',
            partialSelected: isAllChecked || mappedValueList.includes(productDescription.itemKey),
            styleClass: nodeClass,
            draggable: false,
            droppable: false,
            selectable: selectable,
            isRoot: true,
            level: 4,
            // checked: mappedTimeFrame.length > 0 && mappedTimeFrame.includes(yearList.weekNumber),
          };

          if (productDescriptionObject) {
            parentProductObject.children.push(productDescriptionObject);
          }
        });
        if (parentProductObject) {
          productGroupObject.children.push(parentProductObject);
        }
      });
      if (productGroupObject) {
        brandsObject.children.push(productGroupObject);
      }
    });
    treeList.push(brandsObject);
  });

  return treeList;
}

export const SK_CreateForecastCalendarList = (
  calendarListDropdown: any,
  timeframeList: any,
  mappedTimeFrame: any,
  selectable: boolean = true,
  expanded: boolean = false,
  nodeClass?: string
) => {
  calendarListDropdown = [];

  const uniqueYears: any = [
    ...new Set(timeframeList.map((item: any) => item.reportYear)),
  ];
  uniqueYears.forEach((year: string, index: number) => {
    const yearList = timeframeList.filter((row: any) => row.reportYear === year);
    const uniqueHalfYears = [
      ...new Set(yearList.map((item: any) => item.reportHalf)),
    ];
    const uniqueQuarters: any = [];
    const uniqueMonths: any = [];
    const uniqueWeeks: any = [];
    yearList.forEach((y: any) => {
      if (
        uniqueQuarters.findIndex(
          (x: any) => x.quater === y.quater && x.reportHalf === y.reportHalf
        ) < 0
      ) {
        uniqueQuarters.push({ quater: y.quater, reportHalf: y.reportHalf });
      }
      if (
        uniqueMonths.findIndex(
          (x: any) => x.quater === y.quater && x.reportMonth === y.reportMonth
        ) < 0
      ) {
        uniqueMonths.push({ quater: y.quater, reportMonth: y.reportMonth });
      }
      if (
        uniqueWeeks.findIndex(
          (x: any) => x.quater === y.quater && x.reportMonth === y.reportMonth && x.weekStartDate === y.weekStartDate
        ) < 0
      ) {
        uniqueWeeks.push({ quater: y.quater, reportMonth: y.reportMonth, weekStartDate: y.weekStartDate });
      }
      y.checked =
        mappedTimeFrame && mappedTimeFrame.weekNumber
          ? mappedTimeFrame.weekNumber
            .split(',')
            .find((val: any) => val === y.weekNumber.toString())
          : false;
    });
    const obj = {
      label: year,
      key: year,
      data: year,
      icon: '',
      leaf: false,
      expanded: false,
      type: '',
      partialSelected: false,
      styleClass: nodeClass,
      draggable: false,
      droppable: false,
      selectable: selectable,
      isRoot: true,
      level: 1,
      // checked: mappedTimeFrame.length > 0 && mappedTimeFrame.includes(yearList.weekNumber),
      children: uniqueHalfYears.map(
        (h: any) => {
          return {
            label: h,
            key: h,
            data: h,
            icon: '',
            leaf: false,
            expanded: false,
            type: '',
            partialSelected: false,
            styleClass: nodeClass,
            draggable: false,
            droppable: false,
            selectable: selectable,
            isRoot: true,
            level: 2,
            // checked: mappedTimeFrame.length > 0 && mappedTimeFrame.includes(yearList.weekNumber),
            children: uniqueQuarters
              .filter((e: any) => e.reportHalf === h)
              .map(
                (q: any) => {
                  return {
                    label: q.quater,
                    key: q.quater,
                    data: q,
                    icon: '',
                    leaf: false,
                    expanded: false,
                    type: '',
                    partialSelected: false,
                    styleClass: nodeClass,
                    draggable: false,
                    droppable: false,
                    selectable: selectable,
                    isRoot: true,
                    level: 3,
                    // checked: mappedTimeFrame.length > 0 && mappedTimeFrame.includes(yearList.weekNumber),
                    children: uniqueMonths
                      .filter((el: any) => el.quater === q.quater)
                      .map((m: any) => {
                        return {
                          label: m.reportMonth,
                          key: m.reportMonth,
                          data: m,
                          icon: '',
                          leaf: false,
                          expanded: false,
                          type: '',
                          partialSelected: false,
                          styleClass: nodeClass,
                          draggable: false,
                          droppable: false,
                          selectable: selectable,
                          isRoot: true,
                          level: 4,
                          // checked: mappedTimeFrame.length > 0 && mappedTimeFrame.includes(yearList.weekNumber),
                          children: yearList
                            .filter(
                              (el: any) =>
                                el.reportMonth === m.reportMonth &&
                                el.quater === q.quater &&
                                el.reportHalf === h
                            )
                            .map(
                              (row: any) => {
                                return {
                                  label: moment.utc(row.weekStartDate).format('M/DD/YYYY'),
                                  key: row.weekNumber,
                                  data: row,
                                  icon: '',
                                  leaf: true,
                                  expanded: false,
                                  type: '',
                                  partialSelected: false,
                                  styleClass: nodeClass,
                                  draggable: false,
                                  droppable: false,
                                  selectable: selectable,
                                  isRoot: true,
                                  level: 5,
                                  // checked: mappedTimeFrame.length > 0 && mappedTimeFrame.includes(yearList.weekNumber),
                                }
                              }),
                        }
                      }),
                  }
                }
              ),
          }
        }
      ),
    };
    calendarListDropdown.push(obj);
  });
  return calendarListDropdown;
};


